import { ONE_MINUTE } from '../constants';

export const getNextMinute = (): Date => {
  const date = new Date().setSeconds(0, 0) + ONE_MINUTE;

  return new Date(date);
};
